import React from 'react';

export default ({ children, color, icon, ...rest }) => <div {...rest}> <button type="button" className={`btn btn-${color ? color : "primary"}`}>{children} {icon ? <Icon icon={icon} /> : ""}</button></div>;

export const Icon = ({ icon }) => <i className={`fas fa-sm ${icon}`}/>;